import React from 'react';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function OperatingAmounts(props) {
    return (<>
        <h4>Operating Amounts</h4>
        <ResultValue label="O-FSP" value={formatStringAsCurrency(props.result.opFSP)} />
        <ResultValue label="O-HSP" value={formatStringAsCurrency(props.result.opHSP)} />
        <ResultValue label="O-Outlier" value={formatStringAsCurrency(props.result.opOutlier)} />
        <ResultValue label="O-IME" value={formatStringAsCurrency(props.result.opIME)} />
        <ResultValue label="O-DSH" value={formatStringAsCurrency(props.result.opDSH)} />
    </>);
}